import {Injectable} from '@angular/core';
import {EnvironmentConfig} from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ColorPaletteService {

  private index: number = 0;

  public getNextColor(): string {
    const color = EnvironmentConfig.PortalSettings.colorPalette[this.index];
    this.updateIndex();
    return color;
  }

  public colorInPalette(color: string): boolean {
    return EnvironmentConfig.PortalSettings.colorPalette.includes(color);
  }

  private updateIndex(): void {
    this.index = (this.index + 1) % EnvironmentConfig.PortalSettings.colorPalette.length;
  }
}
